import styled from 'styled-components';
import React, { forwardRef, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
const Container = styled.div `
  display: flex;
  flex-direction: column-reverse;
  overflow: hidden auto;
  overscroll-behavior: contain;
  padding: 2rem 1.25rem;
  flex-grow: 1;
  scroll-snap-type: ${({ isSnapped }) => (isSnapped ? 'y mandatory' : 'none')};
`;
const EndSnappingAnchor = styled.div `
  scroll-snap-align: end;
  scroll-margin-block-end: 0;
  margin-top: 1rem;
`;
export const ChatboxMessageContainer = forwardRef(({ onCloseToTop, onSnapToLatestChange, children }, ref) => {
    const [startAnchorRef, startInView] = useInView();
    const [endAnchorRef, endInView] = useInView();
    useEffect(() => {
        onSnapToLatestChange === null || onSnapToLatestChange === void 0 ? void 0 : onSnapToLatestChange(endInView);
    }, [endInView, onSnapToLatestChange]);
    useEffect(() => {
        if (startInView)
            onCloseToTop === null || onCloseToTop === void 0 ? void 0 : onCloseToTop();
    }, [onCloseToTop, startInView]);
    return (React.createElement(Container, { ref: ref, isSnapped: endInView, "data-testid": "chat-box-message-container" },
        React.createElement("div", null,
            React.createElement("div", { ref: startAnchorRef }),
            children,
            React.createElement(EndSnappingAnchor, { ref: endAnchorRef }))));
});
//# sourceMappingURL=ChatboxMessageContainer.js.map